import { render, staticRenderFns } from "./LogAs.vue?vue&type=template&id=445b6dd8&"
import script from "./LogAs.vue?vue&type=script&setup=true&lang=js&"
export * from "./LogAs.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports